// @flow

import { type Ui } from './types';

function getIgnoreAddress(ui: Ui): ?bool {
  return ui['ignore_address'];
}

export function shouldIgnoreAddress(ui: Ui): bool {
  return !!getIgnoreAddress(ui);
}
